import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import authors from './modules/authors';
import backups from './modules/backups';
import books from './modules/books';
import categories from './modules/categories';
import common from './modules/common';
import configuration from './modules/configuration';
import impressum from './modules/impressum';
import lawyers from './modules/lawyers';
import publishers from './modules/publishers';
import slider from './modules/slider';
import stats from './modules/stats';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},

  getters: {},

  modules: {
    auth,
    authors,
    backups,
    books,
    categories,
    common,
    configuration,
    impressum,
    lawyers,
    publishers,
    slider,
    stats,
  },
  strict: process.env.NODE_ENV !== 'production'
})